import React from "react";

const Col = ({ width, children }) => (
  <div className="col" style={{ width: `${width}%` }}>
    {children}
  </div>
);

export default Col;
